import styled from "@emotion/styled";

export const PageRoot = styled.div`
    width: 100%;
    background: #1a1a1c;
    display: flex;
    flex-direction: column;

    position: fixed;
    inset: 0;

    overflow: hidden;

    @supports (height: 100dvh) {
        height: 100dvh;
    }

    @supports (-webkit-touch-callout: none) {
        height: -webkit-fill-available;
    }
`;

export const PageInner = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;

    padding-left: 16px;
    padding-right: 16px;

    @media (min-width: 1024px) {
        padding-left: 48px;
        padding-right: 48px;
    }
`;

export const CenterStack = styled.div`
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    flex: 1;

    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 1023px) {
        max-width: 100%;
    }
`;

export const DockWrapper = styled.div`
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
`;

export const VSpace = styled.div<{
    $h?: number;
    $hMobile?: number;
    $hSmallMobile?: number;
}>`
    height: ${(p) => p.$h ?? 0}px;
    flex-shrink: 0;

    @media (max-width: 1023px) {
        height: ${(p) => p.$hMobile ?? p.$h ?? 0}px;
    }

    @media (max-width: 380px) {
        height: ${(p) => p.$hSmallMobile ?? p.$hMobile ?? p.$h ?? 0}px;
    }
`;
